import type { PipelineReviewStatus } from '@/api/entity_types/PipelineReview';

export type StatusFilterValue = PipelineReviewStatus | 'All';

export type FilterOption<T extends string = string> = { value: T; label: string };

export const STATUS_OPTIONS: FilterOption<StatusFilterValue>[] = [
  { value: 'All', label: 'All statuses' },
  { value: 'done', label: 'Done' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'expired', label: 'Expired' },
];

export const REVIEW_TYPE_OPTIONS: FilterOption[] = [
  { value: 'All', label: 'All types' },
  { value: 'sync', label: 'Sync' },
  { value: 'async', label: 'Async' },
];

export const STATUS_LABELS: Record<PipelineReviewStatus, string> = {
  done: 'Done',
  in_progress: 'In progress',
  expired: 'Expired',
};

export const STATUS_VARIANTS: Record<PipelineReviewStatus, 'green' | 'blue' | 'red'> = {
  done: 'green',
  in_progress: 'blue',
  expired: 'red',
};

export const isStatusFilterValue = (value: unknown): value is StatusFilterValue =>
  typeof value === 'string' && STATUS_OPTIONS.some(option => option.value === value);
